<div class="container padding-left-zero">
  <div *ngIf="label">
    <label [ngClass]="{ required: isRequired }">{{ label }}</label>
  </div>
  <div class="upload-input-container">
    <div class="input-clear-container">
      <input
        class="doc-submit-inputs"
        [class]="fileData.filename != null ? 'clearable-text' : ''"
        pInputText
        type="text"
        name="{{ inputName }}Title"
        [(ngModel)]="fileData.filename"
        #{{inputName}}Title="ngModel"
        readonly
        [required]="isRequired" />
      <button
        *ngIf="fileData.filename && !isClearButtonDisabled"
        class="clear-btn"
        type="button"
        (click)="clearInput()"
        pButton
        icon="pi pi-times"
        [disabled]="isClearButtonDisabled"></button>
    </div>
    <p-fileUpload
      *ngIf="!isDetailsView"
      chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
      name="uploader"
      #uploader
      (onSelect)="onSelectFile($event, uploader)"
      mode="basic"
      [disabled]="isUploadDisabled"></p-fileUpload>
    <button
      *ngIf="isDetailsView && fileData.filename"
      (click)="previewDocument()"
      class="view-btn-width view-btn"
      label="{{ 'view-button-label' | translate }}"
      pButton
      type="button"></button>
  </div>
  <p-toast></p-toast>
</div>
